









import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CompetenceCardMoreButton extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly isRightBadge: boolean;

  get text(): string {
    return this.isRightBadge ? 'проф.' : 'прогр.';
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/competences/card/components/badge/Badge.vue